// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y6Ch","left":"styles_left__1rBIe","desktopActions":"styles_desktopActions__3fYAP","title":"styles_title__usO8m"};